import { Box, WizardStepRenderParams, useOnNext } from '@factorialco/deprecated-design-system'
import { LegalEntityForSelectFragment } from 'generated/resources/graphql'

import { LegalEntitySelector } from 'modules/core/components/LegalEntitySelector'
import { useUnsafeCallback } from 'modules/core/hooks/useCallback'
import i18n from 'modules/core/lib/i18n'

import { WizardData } from 'modules/banking/components/NewAccountModal/types'
import { WizardStepLayout } from 'modules/banking/components/NewAccountModal/wizardSteps/WizardStepLayout'
import { defaultBankNumberFormat } from 'modules/banking/lib/bankAccountNumbersHelpers'

export const LegalEntityWizardStep = ({
  data,
  onDataChanged,
}: WizardStepRenderParams<WizardData>) => {
  const handleFieldChanged = useUnsafeCallback(
    (newLegalEntity?: LegalEntityForSelectFragment) => {
      onDataChanged({
        ...data,
        legalEntity: newLegalEntity ?? null,
        currency: newLegalEntity?.currency || data.currency,
        accountNumberType: newLegalEntity?.country
          ? defaultBankNumberFormat(newLegalEntity.country)
          : data.accountNumberType,
        country: newLegalEntity?.country.toLocaleUpperCase() ?? data.country,
      })
    },
    [data, onDataChanged]
  )

  // As there is another step using this.. we have to override the onNext callback
  useOnNext(() => Promise.resolve())

  return (
    <WizardStepLayout
      title={i18n.t('banking.accounts.new_wizard.step_1.title')}
      subtitle={i18n.t('banking.accounts.new_wizard.step_1.subtitle')}
    >
      <Box style={{ width: '500px' }} flexDirection="row" gap="s48">
        <Box width="full" flexNoShrink flexDirection="column" gap="s8">
          <LegalEntitySelector
            onChange={(entity) => handleFieldChanged(entity ?? undefined)}
            value={data.legalEntity ?? null}
            multiple={false}
            mandatory
            width="s300"
            emptyLabel={i18n.t('common.select')}
            label={i18n.t('banking.accounts.side_panel.legal_entity')}
          />
        </Box>
      </Box>
    </WizardStepLayout>
  )
}
